import { User } from "../interface";
import { loadAll } from "../actions/loadAll";

async function getUsers(): Promise<User[]> {
    const users = await loadAll("/users/");
    return users as User[];
}

export { getUsers };
